import React from "react";
import { Button, Grid, Link } from "@mui/material";
import IosButton from "../../assets/images/ios-button.svg";
import AndroidButton from "../../assets/images/android-button.svg";

const sxStyles = {
  mainContainer: {
    display: "flex",
    justifyItems: "flex-start",
    width: "320px",
    height: "56px",
    marginTop: "10px",
  },
};

const PlatformBox = () => {
  return (
    <Grid sx={sxStyles.mainContainer}>
      <Button
        sx={{
          "&.MuiButtonBase-root:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Link
          href={"https://apps.apple.com/us/app/bizarrapp/id6443452982"}
          target={"_blank"}
        >
          <img src={IosButton} alt={""} width={250} height={60} />
        </Link>
      </Button>
      <Button
        sx={{
          "&.MuiButtonBase-root:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Link
          href={"https://play.google.com/store/apps/details?id=com.enigma.bzrp"}
          target={"_blank"}
        >
          <img src={AndroidButton} alt={""} width={250} height={60} />
        </Link>
      </Button>
    </Grid>
  );
};

export default PlatformBox;
